export const references = {
  heading: 'References',
  description:
    'Check out the features available on our PayPal Commerce Platform.',
  data: [
    {
      image:
        'https://www.paypalobjects.com/ppdevdocs/multipartyimages/document.png',
      tag: '',
      heading: 'Get started',
      description: 'Get your API credentials and sandbox account information.',
      link: 'https://developer.paypal.com/docs/multiparty/get-started/',
    },
    {
      image:
        'https://www.paypalobjects.com/ppdevdocs/multipartyimages/document.png',
      tag: '',
      heading: 'Onboard sellers',
      description:
        'Onboard sellers onto your platform while retaining control of the experience.',
      link: 'https://developer.paypal.com/docs/multiparty/seller-onboarding/',
    },
    {
      image:
        'https://www.paypalobjects.com/ppdevdocs/multipartyimages/document.png',
      tag: '',
      heading: 'Reports',
      description:
        'Enhance your business with detailed reconciliation and transaction history.',
      link: 'https://developer.paypal.com/docs/multiparty/reports/',
    },
  ],
}
